// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-container[data-v-38e1cee6] {\n  text-align: end;\n}\n.comment__container[data-v-38e1cee6] {\n  background-color: white;\n  border-radius: 3px;\n}\n[data-v-38e1cee6] .timeline__content::before {\n  height: calc(100% + 30px) !important;\n  top: 15px !important;\n}\n[data-v-38e1cee6] .timeline__content::after {\n  top: 15px !important;\n}\n[data-v-38e1cee6] .custom-time-line .timeline__content--inner {\n  padding: unset !important;\n}", ""]);
// Exports
module.exports = exports;
